<template>
  <Modal v-model="modal" :title="$t('title.w55')" :mask-closable="false" :footer-hide="true" class="freezes" width="750px">
    <div>
      <Datatable
        url="/Member/RZJFund/Freezes"
        field="FreezeItems"
        :colcount="4"
        :tip="$t('msg.m109')"
        >
        <tr slot="th" class="thead">
          <th>{{$t('label.w198')}}</th>
          <th>{{$t('label.w159')}}</th>
          <th>{{$t('label.w129')}}</th>
          <th>{{$t('label.w169')}}</th>
          <!-- <th>{{$t('label.w167')}}</th> -->
        </tr>
        <template v-slot="{item}">
          <tr>
            <td>{{item.CreatedAt}}</td>
            <td>{{item.FreezeAccountTypeName}}</td>
            <td>{{item.PurposeName}}</td>
            <td>{{item.Amount | money}}</td>
            <!-- <td>{{item.Description}}</td> -->
          </tr>
        </template>
      </Datatable>
    </div>
  </Modal>
</template>

<script>
import Datatable from '@/components/datatable'
export default {
  components:{Datatable},
  data() {
    return {
      modal: false
    };
  },
  methods: {
  },
  computed: {
  },
  watch: {
  }
};
</script>
<style lang="less" scoped>
.thead{
  th{
    background: none;
    color: #555;
  }
}
.freezes{
  /deep/ .ivu-modal-body{
    padding: 0 !important;
  }
}
</style>

